import { UniqueIdentifier, Timestamp } from '@/api/types/base'
import { UserIdentifier } from '@/api/types/user'
import { EventDocument, EventCategory, ResourceType } from '@/api/types/event'

export type EventsState = {
  usage: Array<EventDocument> | null
}

export interface IUsageDocument {
  readonly uuid: UniqueIdentifier
  readonly timestamp: Timestamp
  readonly categoryName: EventCategory
  readonly resource: ResourceType
  readonly userId: UserIdentifier
  readonly resourceId: UniqueIdentifier
  // After calculating these new UsageEvent is returned with additional information
  readonly durationHours?: number
  // For session connect and disconnect
  readonly resourceTimestamp?: Timestamp
  readonly source?: EventSource
  readonly action?: string
  readonly resourceType?: string
}

export interface UsageDocument extends IUsageDocument {}

export class UsageDocument {
  public constructor(props: IUsageDocument) {
    Object.assign(this, props)
  }
}

export interface IUsageTableRowDocument {
  action: string
  resourceType: string
  user: string
  date: string
}

export interface UsageTableRowDocument extends IUsageTableRowDocument {}

export class UsageTableRowDocument {
  public constructor(props: IUsageTableRowDocument) {
    Object.assign(this, props)
  }
}
